import {isArray} from 'features/services/utils/helpers';
import {ObjectImageType} from 'features/template/viewModels';
import {EpiImageWithType} from "features/search/types";

export const getObjectImageByType = (images: EpiImageWithType[], type: ObjectImageType) => {
    if(!images) return null;
    if(images.length === 0) return null;

    const image = images.filter(image => image.type === type);

    if(image.length === 0) return null;

    return image[0];
};

export const getObjectImagesByType = (images: EpiImageWithType[], type: ObjectImageType[] | string) => {
    if(!images) return null;
    if(images.length === 0) return null;

    let image: EpiImageWithType[];

    if(isArray(type)) {
        image = images.filter(image => type.includes(image.type));
    } else {
        image = images.filter(image => image.type === type);
    }

    if(image.length === 0) return null;

    return image;
};
